import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'shared/i18n'
import DocumentLayout from 'shared/ui/DocumentLayout'

const StyledOrderedList = styled('ol')({
  '& > li::marker': {
    fontSize: '1.25rem',
    fontFamily: 'Public Sans, sans-serif'
  },
  '& p': {
    marginBlockStart: '1rem',
    marginBlockEnd: '1rem'
  },
  '& ol': {
    marginBlockStart: '1rem',
    marginBlockEnd: '1rem'
  }
})

export default function ViewPrivacyPolicy2 (): JSX.Element {
  const { t } = useTranslation()
  return (
    <DocumentLayout title={t('privacyPolicy.view.title')}>
      <StyledOrderedList>
        <li>
          <Typography variant="h4">{t('privacyPolicy.view.text')}</Typography>
          <Typography>
            {t('privacyPolicy.view.text2')}
          </Typography>
        </li>
        <li>
          <Typography variant="h4">{t('privacyPolicy.view.text3')}</Typography>
          <Typography>
            {t('privacyPolicy.view.text4')}
          </Typography>
          <ol>
            <li>
              {t('privacyPolicy.view.li')}
            </li>
            <li>
              {t('privacyPolicy.view.li2')}
            </li>
            <li>{t('privacyPolicy.view.li3')}</li>
            <li>
              {t('privacyPolicy.view.li4')}
            </li>
            <li>{t('privacyPolicy.view.li5')}</li>
            <li>{t('privacyPolicy.view.li6')}</li>
            <li>{t('privacyPolicy.view.li7')}</li>
            <li>
              {t('privacyPolicy.view.li8')}
            </li>
            <li>{t('privacyPolicy.view.li9')}</li>
          </ol>
        </li>
        <li>
          <Typography variant="h4">{t('privacyPolicy.view.text5')}</Typography>
          <Typography>
            {t('privacyPolicy.view.text6')}
          </Typography>
        </li>
        <li>
          <Typography variant="h4">{t('privacyPolicy.view.text7')}</Typography>
          <Typography>
            {t('privacyPolicy.view.text8')}
          </Typography>
        </li>
        <li>
          <Typography variant="h4">{t('privacyPolicy.view.text9')}</Typography>
          <Typography>
            {t('privacyPolicy.view.text10')}
          </Typography>
          <ol>
            <li>{t('privacyPolicy.view.li10')}</li>
            <li>
              {t('privacyPolicy.view.li11')}
            </li>
            <li>
              {t('privacyPolicy.view.li12')}
            </li>
            <li>
              {t('privacyPolicy.view.li13')}
            </li>
            <li>
              {t('privacyPolicy.view.li14')}
            </li>
          </ol>
        </li>
        <li>
          <Typography variant="h4">{t('privacyPolicy.view.text11')}</Typography>
          <Typography>{t('privacyPolicy.view.text12')}</Typography>
        </li>
        <li>
          <Typography variant="h4">{t('privacyPolicy.view.text13')}</Typography>
          <Typography>
            {t('privacyPolicy.view.text14')}
          </Typography>
        </li>
        <li>
          <Typography variant="h4">{t('privacyPolicy.view.text15')}</Typography>
          <Typography>
            {t('privacyPolicy.view.text16')}
          </Typography>
        </li>
        <li>
          <Typography variant="h4">{t('privacyPolicy.view.text17')}</Typography>
          <Typography component="div">
            {t('privacyPolicy.view.text18')}
            <ol>
              <li>{t('privacyPolicy.view.li10')}</li>
              <li>
                {t('privacyPolicy.view.li11')}
              </li>
              <li>
                {t('privacyPolicy.view.li12')}
              </li>
              <li>
                {t('privacyPolicy.view.li13')}
              </li>
              <li>
                {t('privacyPolicy.view.li15')}
              </li>
              <li>{t('privacyPolicy.view.li16')}</li>
              <li>{t('privacyPolicy.view.li17')}</li>
              <li>{t('privacyPolicy.view.li18')}</li>
              <li>
                {t('privacyPolicy.view.li19')}
              </li>
            </ol>
          </Typography>
        </li>
        <li>
          <Typography variant="h4">{t('privacyPolicy.view.text19')}</Typography>
          <Typography>
            {t('privacyPolicy.view.text20')}
          </Typography>
          <ul>
            <li>
              <a href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0">
                Meta Platforms, Inc. (Facebook)
              </a>{' '}
              : <a href="https://www.ppc.go.jp/files/pdf/USA_report.pdf">{t('privacyPolicy.view.text21')}</a>
            </li>
            <li>
              <a href="https://policies.google.com/privacy?hl=ja">Google LLC</a> :{' '}
              <a href="https://www.ppc.go.jp/files/pdf/california_report.pdf">{t('privacyPolicy.view.text21')}</a>
            </li>
          </ul>
        </li>
        <li>
          <Typography variant="h4">{t('privacyPolicy.view.text22')}</Typography>
          <Typography>
            {t('privacyPolicy.view.text23')}
          </Typography>
        </li>
        <li>
          <Typography variant="h4">{t('privacyPolicy.view.text24')}</Typography>
          <Typography>
            {t('privacyPolicy.view.text25')}
          </Typography>
        </li>
        <li>
          <Typography variant="h4">{t('privacyPolicy.view.text26')}</Typography>
          <Typography>
            {t('privacyPolicy.view.text27')}
          </Typography>
        </li>
        <li>
          <Typography variant="h4">{t('privacyPolicy.view.text28')}</Typography>
          <Typography>
            {t('privacyPolicy.view.text29')}
          </Typography>
          <Typography>
            {t('privacyPolicy.view.text30')}
          </Typography>
          <Typography component="div">
            <ul>
              <li>
                <a href="https://www.google.com/analytics/terms/jp.html">{t('privacyPolicy.view.text31')}</a>
              </li>
              <li>
                <a href="http://www.google.com/intl/ja/policies/privacy/">{t('privacyPolicy.view.text32')}</a>
              </li>
              <li>
                <a href="https://policies.google.com/technologies/partner-sites?hl=ja">{t('privacyPolicy.view.text33')}</a>
              </li>
            </ul>
          </Typography>
        </li>
        <li>
          <Typography variant="h4">{t('privacyPolicy.view.text34')}</Typography>
          <Typography>
            {t('privacyPolicy.view.text35')}
          </Typography>
        </li>
      </StyledOrderedList>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '32px' }}>
        <Typography variant="body2">
          {t('privacyPolicy.view.text36')}<br />
          {t('privacyPolicy.view.text37')}
        </Typography>
      </div>
    </DocumentLayout>
  )
}
